import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';

export default function FeaturedArticles() {
  const featured = articles.filter((a) => a.featured);
  const recent = articles.filter((a) => !a.featured).slice(0, 3);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            精选深度文章
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-3 max-w-xl mx-auto">
            由专业团队精心编撰的 hitozuma 文化深度解析内容，涵盖多个维度
          </p>
        </div>

        <div className="flex flex-col gap-6 mb-10">
          {featured.map((article) => (
            <ArticleCard key={article.id} article={article} variant="featured" />
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {recent.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/basics"
            className="inline-flex items-center gap-2 px-6 py-3 bg-background-50 border border-background-300/60 rounded-full text-sm font-medium text-foreground-700 hover:text-primary-500 hover:border-primary-300 transition-all cursor-pointer whitespace-nowrap"
          >
            查看全部文章
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}